import Vue from 'vue'
import _ from 'lodash'

Vue.filter('formatMoney', function (value) {
  if (!_.isNumber(value)) {
    return value
  }
  return value.toFixed(2) + '元'
})



// WEBPACK FOOTER //
// ./src/components/filters.js